import _export from '../internals/export.js';
import aCallable$1 from '../internals/a-callable.js';
import getBuiltIn$1 from '../internals/get-built-in.js';
import functionCall from '../internals/function-call.js';
import '../internals/new-promise-capability.js';
import perform$1 from '../internals/perform.js';
import iterate$1 from '../internals/iterate.js';
import { __exports as newPromiseCapability } from '../../../../../../_virtual/new-promise-capability.js';

var $ = _export;
var aCallable = aCallable$1;
var getBuiltIn = getBuiltIn$1;
var call = functionCall;
var newPromiseCapabilityModule = newPromiseCapability;
var perform = perform$1;
var iterate = iterate$1;
var PROMISE_ANY_ERROR = 'No one promise resolved'; // `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any

$({
  target: 'Promise',
  stat: true
}, {
  any: function any(iterable) {
    var C = this;
    var AggregateError = getBuiltIn('AggregateError');
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});
